export default [
  "Kenntnisnahme und Ablage im Schüler*innendossier ohne weitere Massnahmen",
  "Einladung zu einem Gespräch mit der Abteilungsleitung und ggf. weiteren Gesprächsteilnehmenden",
  "Einladung durch das Absenzenkomitee",
  "Antrag zur Eröffnung eines Disziplinarverfahrens beim Rektor",
  "Anderes",
];
